// extracted by mini-css-extract-plugin
module.exports = {"aboutAerobert":"AboutAerobert_aboutAerobert__2oUh_","header_label":"AboutAerobert_header_label__mlubj","description_label":"AboutAerobert_description_label__1Dq7h"};